import { FieldRequest } from '../request-models/field-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * The hub request body for creating or updating a field. Copies only the allowlisted fields and drops the ones
 * that are not set, so an update stays partial; `null` (clear the field) is kept.
 */
export function toFieldRequest(fields: FieldRequest): FieldRequest {
  return omitUndefined<FieldRequest>({
    name: fields.name,
    acreage: fields.acreage,
    cropType: fields.cropType,
    customerId: fields.customerId,
    locationId: fields.locationId,
    latitude: fields.latitude,
    longitude: fields.longitude,
    address: fields.address,
    city: fields.city,
    state: fields.state,
    emergencyContactName: fields.emergencyContactName,
    emergencyContactNumber: fields.emergencyContactNumber,
    loadMixLocationLatitude: fields.loadMixLocationLatitude,
    loadMixLocationLongitude: fields.loadMixLocationLongitude,
    loadMixLocationDescription: fields.loadMixLocationDescription,
    boundaryKml: fields.boundaryKml,
    boundaryGeojson: fields.boundaryGeojson,
    notes: fields.notes,
  });
}
